var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textBox"},[_c('transition',{attrs:{"name":"slide"}},[_c('p',{key:_vm.text.id,staticClass:"text"},[_c('a',{attrs:{"href":_vm.text.link,"target":"_blank"}},[_vm._v("💁 "+_vm._s(_vm.text.val))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }